import React from 'react';
import { useSelector } from 'react-redux';
import { standortUrlSelector } from '../../../modules/selectors/url';
import PropTypes from 'prop-types';
import { ListenerLink } from '../Tracking/Matomo';
import { useStandortAwareHref } from './internal/vHostHelper';
import { validatePage } from './internal/customPropTypesValidators';
// StandortLink abstracts internal shop links.
// eslint-disable-next-line no-restricted-imports
import { Link } from 'react-router-dom';

function InnerStandortLink({ currentStandortUrl, to: page, newStandortUrl, children, forceServerSideRouting = false, ariaLabel, ariaDescribedBy, ...otherProps }) {
    const { routeServerSide, to } = useStandortAwareHref({ page, newStandortUrl, forceServerSideRouting, currentStandortUrl });

    return routeServerSide ? (
        // StandortLink abstracts links to shops on different hosts.
        // eslint-disable-next-line react/forbid-elements
        <ListenerLink  ariaLabel={ariaLabel} {...otherProps} to={to}>
            {children}
        </ListenerLink>
    ) : (
        <Link {...otherProps} to={to} aria-label={ariaLabel} aria-describedby={ariaDescribedBy}>
            {children}
        </Link>
    );
}

InnerStandortLink.propTypes = {
    currentStandortUrl: PropTypes.string.isRequired,
    to: validatePage,
    newStandortUrl: PropTypes.string,
    forceServerSideRouting: PropTypes.bool,
    ariaLabel: PropTypes.string,
    children: PropTypes.node.isRequired,
    ariaDescribedBy: PropTypes.string
};

function StandortLink({ to, newStandortUrl, children, forceServerSideRouting = false, ariaLabel, ariaDescribedBy, ...otherProps }) {
    const currentStandortUrl = useSelector(standortUrlSelector);

    return (
        <InnerStandortLink
            {...otherProps}
            to={to}
            newStandortUrl={newStandortUrl}
            currentStandortUrl={currentStandortUrl}
            forceServerSideRouting={forceServerSideRouting}
            ariaLabel={ariaLabel}
            ariaDescribedBy={ariaDescribedBy}
        >
            {children}
        </InnerStandortLink>
    );
}

StandortLink.propTypes = {
    to: PropTypes.string.isRequired,
    newStandortUrl: PropTypes.string,
    forceServerSideRouting: PropTypes.bool,
    ariaLabel: PropTypes.string,
    children: PropTypes.node.isRequired,
    ariaDescribedBy: PropTypes.string,
};

export default StandortLink;
